import React from 'react'

import type { Instance } from 'mobx-state-tree'

import type { Root } from './models'

export type Mst = Instance<typeof Root>

// Keep the context and its consumers together so its identity remains stable
// during React Fast Refresh.
const MstContext = React.createContext<Mst | null>(null)

export const MstProvider = MstContext.Provider

export function useMst(): Mst {
  const store = React.useContext(MstContext)

  if (store === null) {
    throw new Error('useMst must be used within MstProvider')
  }

  return store
}
